import React, { useState, useEffect } from "react";
import { connect } from 'react-redux'
import axiosInstance from "../authentication/helper/axiosApi";
import PdfResume from "../network/helper/CV/PdfResume";
import UserLayout from '../utils/user/UserLayout'
import { useParams } from "react-router-dom";

export const MyProfile = (props) => {
    
    const params = useParams();
    const [pdfData, setPdfData] = useState([]);
    const [data, setData] = useState({
        is_contact: false,
        is_pdf_data: false
    })

    
    useEffect(() => {
        if (Object.keys(props.profile).length > 0 && data.is_pdf_data === false) {
            axiosInstance.get(`api/network/userProfilePdf/${props.profile.id}/`)
                .then(function (response) {
                    // console.log(response);
                    setData((prevState) => ({ ...prevState, is_pdf_data: true }));
                    setPdfData(response.data);
                });
        }
    }, [props, params.id])
    
    return (
        <div className="mynetwork-page">
            <UserLayout>
                <div className="right-section">
                    <div className="row connection-request-section">
                        <div className="col-12">
                            <div className="border-box">
                                <div className="row small-gutter">

                                    <div className="col-12">
                                        <PdfResume data={pdfData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </UserLayout>
        </div>
    )
}

const mapStateToProps = (state) => {
    const user = state.user.user;
    const profile = state.user.profile;
    return {
        user: user,
        profile: profile,
    };
};

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile)